import { Button } from "@heroui/react";
import clsx from "clsx";
import { twMerge } from "tailwind-merge";

export default function IconButton({ children, ariaLabel, onClick, disabled = false, className = "" }) {
  return (
    <Button
      type="button"
      isIconOnly
      size="sm"
      variant="light"
      aria-label={ariaLabel}
      title={ariaLabel}
      isDisabled={disabled}
      onClick={onClick}
      className={twMerge(clsx("h-8 min-w-8 rounded-lg text-gray-500 hover:text-secondary", className))}
    >
      {children}
    </Button>
  );
}
